module.exports = __webpack_public_path__ + "static/media/blog-36-img2.b92ab0d6.webp";